import * as helpers from './helpers'

const defaultListReducerForPielikumi = helpers.createListReducer({listViewName: 'pielikums_list'})
export const pielikumi = (state = helpers.listGetInitialState(), {type, payload, reqId}) => {
  //overwrite or add custom actions catches here
  return defaultListReducerForPielikumi({state, type, payload, reqId})
}
